import { useMemo } from "react";
import { useParams } from "@/hooks/useSearchParams";
import { GOVERNANCE_ROLE_FILTER_PARAM, parseGovernanceRoleFilterParam } from "./_utils";

export function useGovernanceRoleFilter() {
  const { params, addSearchParam, deleteSearchParams } = useParams();
  const selectedRoleIds = useMemo(() => parseGovernanceRoleFilterParam(params.role), [params.role]);

  function onSelect(value: string, checked: boolean) {
    const next = checked ? [...new Set([...selectedRoleIds, value])] : selectedRoleIds.filter((id) => id !== value);

    if (next.length === 0) {
      deleteSearchParams(GOVERNANCE_ROLE_FILTER_PARAM);
      return;
    }

    addSearchParam(GOVERNANCE_ROLE_FILTER_PARAM, next.join(","));
  }

  function onClear() {
    deleteSearchParams(GOVERNANCE_ROLE_FILTER_PARAM);
  }

  return { selectedRoleIds, onSelect, onClear };
}
